<template lang="pug">
  
  MDashboardWidget( title="Batch Comparison - selected by Batch IDs" )

    div(class="form-group row")
      MModalButton( button-classes="btn-link" class="ml-2" modal-size="modal-lg" title="Selecting categories of Healthy Advertisers" )
        td( slot="button-inner" )
          | Find batch ID from first column of Your Results page
          i( class="fa fa-question inline-block ml-2" )
      div(class="col-sm-10")
        label Primary Batch:
        input( type="text" placeholder="Enter Batch ID" class="form-control" v-model="batchId1" )
      div( class="col-sm-10")
        label Secondary Batch:
        input( type="text" placeholder="Enter Batch ID" class="form-control" v-model="batchId2" )
      div(class="col-sm-12")
        p( class="text-left mt-3" )
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! batchId1 && batchId2 || loading" v-on:click="generateCSV('client-standard')" )
              i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
              | Generate CSV for download
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! batchId1 && batchId2  || loading" v-on:click="generateCSV('debug')" )
              i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
              | Generate Debug Report
        p( class="text-danger m-0" v-if="errorMessage" ) {{ errorMessage }}

    
</template>
<style scoped>
</style>
<script>
import Vue from 'vue'
import gql from "graphql-tag";
export default Vue.extend({
  data() {
    return{
      batchId1: '',
      batchId2: '',
      loading: false,
      errorMessage: ''
    }
  },
  methods: {
    myMethod() {
      console.log("do something");
    },

    async generateCSV(type) {
      this.loading = true

      const { data: { generateMultiBatchCSV } } = await this.$apollo.query({
        query: gql`
          query generateMultiBatchCSV($primaryBatch: ID!, $secondaryBatch: ID! $type: String!) {
            generateMultiBatchCSV(
              primaryBatch: $primaryBatch
              secondaryBatch: $secondaryBatch
              type: $type
            )
          }
        `,
        variables: {
          primaryBatch:  this.batchId1,
          secondaryBatch: this.batchId2,
          type
        }
      })
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.setAttribute('style', 'display:none')
      const blob = new Blob([ generateMultiBatchCSV ], { type: 'octet/stream' })
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = `batches_${this.batchId1}_${this.batchId2}.csv`
      a.click()
      window.URL.revokeObjectURL(url)

      this.loading = false
    }
  },

})
</script>